var target = document.querySelectorAll(".headerMenu span");
for (i in target) {
	let navMenuText = target[i].innerText;
	if (navMenuText == "shop" || navMenuText == "Shop" || navMenuText == "SHOP") {
		target[i].parentNode.addEventListener("mouseover", function (event) {
			var nav = document.querySelector(".nav-wrapper");
			var standard = document.querySelector(".full-width-header");
			nav.classList.add("hover-class");
			standard.classList.add("standard-header");
		});
		target[i].parentNode.addEventListener("mouseout", function (event) {
			var nav = document.querySelector(".nav-wrapper");
			var standard = document.querySelector(".full-width-header");
			nav.classList.remove("hover-class");
			standard.classList.remove("standard-header");
		});
	}
}



// fixed header other pages
window.onscroll = function() {myFunction()};
var header = document.querySelector("#shopify-section-header");
header.classList.add("static-header-block");
var sticky = 5;
var headerClass = document.querySelector('.checkout-custom-body');
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("fixed-header");
  } else {
    header.classList.remove("fixed-header");
  }
}


// fixed header checkout
if (headerClass != undefined) {
	document.addEventListener('scroll', function (event) {
		if (document.body.scrollTop > sticky) {
			header.classList.add("fixed-header");
		} else {
			header.classList.remove("fixed-header");
		}
	},
	true);
}